export default  function generateRating(rating, themeName) {
		const starsSvg = {
			colorStar: '<div class="' + themeName + '-hotel-reviews__star"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13"><path fill-rule="evenodd" d="M7 10.5l-4.114 2.163.785-4.581L.343 4.837l4.6-.669L7 0l2.057 4.168 4.6.669-3.328 3.245.785 4.581z"/></svg></div>',
            halfStar: '<div class="' + themeName + '-hotel-reviews__star"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13"><g fill-rule="evenodd"><path fill="#D6D8DC" d="M7 10.5l-4.114 2.163.785-4.581L.343 4.837l4.6-.669L7 0l2.057 4.168 4.6.669-3.328 3.245.785 4.581z"/><path d="M7 10.5l-4.114 2.163.785-4.581L.343 4.837l4.6-.669L7 0z"/></g></svg></div>',
            greyStar: '<div class="' + themeName + '-hotel-reviews__star"><svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13"><path fill="#D1DDE9" fill-rule="evenodd" d="M7 10.5l-4.114 2.163.785-4.581L.343 4.837l4.6-.669L7 0l2.057 4.168 4.6.669-3.328 3.245.785 4.581z"/></svg></div>'
		}

		const maxStarCount = 5

		let result = '', starCount = 0
		for(let i = 0; i < maxStarCount && i < Math.floor(rating); i++, starCount++)
			result += starsSvg.colorStar

		if(!Number.isInteger(+rating)) {
			result += starsSvg.halfStar
			starCount++
		}

		for(let i = 0; i < maxStarCount - starCount; i++)
			result += starsSvg.greyStar

		return result
	}
